<div
  class="flex h-full flex-grow flex-col"
  appResize
  (resized)="handleResized($event)"
>
  @if (lastResizeEvent(); as e) {
    <!-- <p class="text-red-500">width={{ e.width }}px, height={{ e.height }}px</p> -->
    <!-- WILL NOT BECOME SMALLER BECAUSE THE PDF IS TOO LARGE! -->
  }
  <div class="mx-4 my-2 flex flex-row justify-between">
    <button
      (click)="pageNumber = pageNumber - 1"
      [disabled]="pageNumber <= 1"
      class="btn btn-primary my-2"
    >
      <
    </button>

    <!-- we can't use @if ...  because angular does not support ng-content in structural directives! -->
    <div
      [class.hidden]="numPages != pageNumber || showPageNumberOnLastPage()"
      class="my-2"
    >
      <ng-content></ng-content>
    </div>

    @if (
      (numPages != pageNumber || showPageNumberOnLastPage()) && pageNumber > 0
    ) {
      <p class="my-2 text-lg">{{ pageNumber }} / {{ numPages }}</p>
    }

    <button
      (click)="pageNumber = pageNumber + 1"
      [disabled]="pageNumber == numPages"
      class="btn btn-primary my-2"
    >
      >
    </button>
  </div>

  <div class="flex flex-col items-center">
    <app-loading-indicator
      [isLoading]="!hasRenderedFirstPage"
    ></app-loading-indicator>

    <!-- {{ pdfWidth }} x {{ pdfHeight }} -->

    <!-- Setting the [width] and [height] to less than 10 as fallback causes the PDF render to fail and thus not show any pdf at all. -->
    <pdf-viewer
      [srcUrl]="pdfUrl()"
      (pdfLoaded)="pdfLoaded($event)"
      [pageNumber]="pageNumber"
      [width]="!hasRenderedFirstPage ? 10 : pdfWidth"
      [height]="!hasRenderedFirstPage ? 10 : pdfHeight"
      (firstPageRendered)="handleFirstPageRendered()"
    ></pdf-viewer>
  </div>
</div>
